import { render, staticRenderFns } from "./WhiteDataTabs.vue?vue&type=template&id=eb2a28e8&scoped=true&"
import script from "./WhiteDataTabs.vue?vue&type=script&lang=js&"
export * from "./WhiteDataTabs.vue?vue&type=script&lang=js&"
import style0 from "./WhiteDataTabs.vue?vue&type=style&index=0&id=eb2a28e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2a28e8",
  null
  
)

export default component.exports